


































import Vue from 'vue'
import Modal from '@/pmd/components/common/Modal.vue'

export default Vue.extend({
  props: ['modalShow'],
  components: {
    Modal,
  },
  data() {
    return {
      popupWidth: 500,
      loader: false,
    }
  },
  methods: {
    async closeModal() {
      this.$root.$emit('close-nogmb-modal')
    },
    tryagain() {
      this.$root.$emit('google-connect')
    },
  },
})
